export const api = process.env.REACT_APP_API;

/** Design tokens aligned with visor_landing_v2 globals.css */
export const fontFamily = 'Inter, -apple-system, BlinkMacSystemFont, sans-serif';

export const borderRadius = '8px';
export const inputPadding = '8px 12px';
export const inputColor = 'var(--foreground)';
export const errorColor = '#EF4444';
export const inputColorDarkMode = '#f6f6f6';
/** Page / layout background — legacy name kept for imports */
export const textColorLight = 'var(--background)';
export const textColorDark = 'var(--foreground)';
export const modalTextColor = 'var(--foreground)';

export const primaryColor = '#2B7FFF';
/** Wordmark on landing: Tailwind v4 text-blue-600 — oklch(54.6% 0.245 262.881) */
export const brandWordmarkColor = '#155dfc';
export const primaryColorTransparent = 'rgba(43, 127, 255, 0.12)';
export const primaryColorGradient =
  'linear-gradient(90deg, #1d6fe8 0%, #2B7FFF 100%)';
export const deleteButton = 'var(--destructive)';
export const cancelButton = 'var(--cancel-button)';

export const sidebarBackground = 'var(--sidebar)';
export const darkBackground = 'var(--background)';
export const mutedForeground = 'var(--muted-foreground)';
export const borderColor = 'var(--border)';
export const shellDivider = 'var(--shell-divider)';
export const shellDividerSoft = 'var(--shell-divider-soft)';
export const cardBackground = 'var(--card)';

/** Shadows — landing card style */
export const cardShadow = 'var(--card-shadow)';
export const cardShadowLg = 'var(--card-shadow-lg)';
export const primaryHover = '#1d6fe8';
export const primaryForeground = '#FFFFFF';
export const tableHeaderBg = 'var(--table-header-bg)';
export const tableRowAltBg = 'var(--table-row-alt-bg)';
export const tableRowBorder = 'var(--table-row-border)';

export const graphBoxBackground = 'var(--card)';
export const graphBoxBackgroundDarkMode = 'rgb(0, 0, 0, 3)';
export const inputBackground = 'var(--input)';
export const inputBackgroundDarkMode = 'rgba(255, 255, 255, .3)';
export const inputBackgroundFocus = 'rgba(43, 127, 255, 0.12)';

/** Disabled / inactive UI */
export const disabledForeground = 'var(--disabled-foreground)';
export const inactiveControl = 'var(--inactive-control)';

export const navbarSize = 'min(15vw, 300px)';
export const miniNavbarSize = '72px';
export const navbarMinSize = '200px';
export const headerSize = 60;
export const headerMobileSize = 50;

export const modalSize = "30vw";

export const textSize = {
  S: '14px',
  M: '18px',
  L: '24px',
};

export const inputSize = {
  ES: '90px',
  S: '160px',
  M: '250px',
  L: '350px',
};

export const imageSize = {
  S: '120px',
  M: '250px',
  L: '400px',
};

export const MainPageTableSizes = {
  S: '400px',
  M: '450px',
  L: '500px'
}

export const skeleton = {
  Width: '100%',
  Height: '800%',
  PositionTop: '-400%',
  BackgroundColor: 'var(--muted)',
  BackgroundColorLineGradient:
    'linear-gradient(90deg, transparent 0%, var(--muted-foreground) 40%, transparent 100%)',
  Animation: 'shining 1.5s infinite',
  Transform: 'rotate(45deg)',
};

export const sizes = {
  mobile: 575,
  tablet: 1024,
  desktop: 1024,
}

export const media = {
  mobile: `@media (max-width: ${sizes.mobile}px)`,
  tablet: `@media (min-width: ${sizes.mobile + 1}px) and (max-width: ${sizes.tablet}px)`,
  desktop: `@media (min-width: ${sizes.tablet + 1}px)`,
};
